module.exports = __webpack_public_path__ + "img/product16.28141ab3.png";